// TeamTaskNotificationManager.jsx
import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import TeamTaskNotification from "./TeamTaskNotification";
import { useRealtimeSync } from "../../hooks/useRealtimeSync";
import { toast } from "react-hot-toast";
import { useTheme } from "../../contexts/ThemeContext";

const TeamTaskNotificationManager = () => {
  const [notifications, setNotifications] = useState([]);
  const navigate = useNavigate();
  const { isDarkMode } = useTheme();

  // Handle incoming team task notifications via WebSocket
  const handleTeamTaskNotification = useCallback((data) => {
    if (data.action === "new_task_assigned") {
      // Add notification to queue
      setNotifications((prev) => [
        ...prev,
        {
          id: `${data.data.id}-${Date.now()}`,
          task: data.data,
          timestamp: data.timestamp,
        },
      ]);

      // Play notification sound (optional)
      playNotificationSound();

      // Show browser notification if permissions granted
      if ("Notification" in window && Notification.permission === "granted") {
        new Notification("New Team Task Assigned", {
          body: data.data.title,
          icon: "/logo.png",
          tag: data.data.id,
        });
      }
    }
  }, []);

  // Set up WebSocket listener
  useRealtimeSync({
    events: ["team_task_notification"],
    onUpdate: handleTeamTaskNotification,
    enabled: true,
  });

  const playNotificationSound = () => {
    try {
      const audio = new Audio("/sounds/notification.mp3");
      audio.volume = 0.5;
      audio.play().catch((err) => console.log("Audio play failed:", err));
    } catch (error) {
      console.log("Notification sound failed:", error);
    }
  };

  const handleCloseNotification = (id) => {
    setNotifications((prev) => prev.filter((n) => n.id !== id));
  };

  const handleViewTask = (taskId) => {
    navigate(`/team-tasks/${taskId}`);
  };

  // Request notification permission on mount
  useEffect(() => {
    if ("Notification" in window && Notification.permission === "default") {
      Notification.requestPermission();
    }
  }, []);

  return (
    <>
      {notifications.map((notification, index) => (
        <div
          key={notification.id}
          style={{
            transform: `translateY(${index * 10}px)`,
            zIndex: 99999 - index,
          }}
        >
          <TeamTaskNotification
            task={notification.task}
            onClose={() => handleCloseNotification(notification.id)}
            onView={handleViewTask}
          />
        </div>
      ))}
    </>
  );
};

export default TeamTaskNotificationManager;
